import { useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import { initialUserValues } from '../../../_models/product-model';
import { ProductEditModalForm } from './_productForm';
import { DisableSidebar, PageLink, PageTitle } from '../../../_metronic/layout/core';

const profileBreadCrumbs: Array<PageLink> = [
    {
        title: 'Products',
        path: '/products',
        isSeparator: false,
        isActive: false,
    }
]

export function AddEditProduct(props: any) {

    const { id } = useParams();
    const [title, setTitle] = useState<any>(id == null ? "Add" : "Edit");

    useEffect(() => {

    }, []);

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Add Product</PageTitle>
            <DisableSidebar>
                <ProductEditModalForm
                    isUserLoading={false}
                    product={initialUserValues}
                    setItemIdForUpdate={props.setItemIdForUpdate}
                    setShowProductForm={props.setShowProductForm}
                    afterUpdateProduct={props.afterUpdateProduct}
                    isService={props.isService}
                />
            </DisableSidebar>
        </>


    )
}